module.exports = __webpack_public_path__ + "img/noimage.511ff514.png";